// Date 2020-07-27 14:39:38

import emMaMaintenanceCat from "@/store/em/maintenance/EmMaMaintenanceCatStore.js";
import emMaMaintenanceSchedule from "@/store/em/maintenance/EmMaMaintenanceScheduleStore.js";
import emMaMaintenanceWo from "@/store/em/maintenance/EmMaMaintenanceWoStore.js";

const genericEntities = [
    'emMaMaintenanceCat',
    'emMaMaintenanceSchedule',
    'emMaMaintenanceWo'
]

const entities = {
    emMaMaintenanceCat,
    emMaMaintenanceSchedule,
    emMaMaintenanceWo
}

export {genericEntities}

export default entities